import { useMediaQuery } from "@/lib/useMediaQuery"

export const SHORT_SCREEN_MAX_HEIGHT_PX = 800
export const MED_SCREEN_MAX_HEIGHT_PX = 900

const shortScreenQuery = `(max-height: ${SHORT_SCREEN_MAX_HEIGHT_PX}px)`
const medScreenQuery = `(max-height: ${MED_SCREEN_MAX_HEIGHT_PX}px)`

export function useIsShort(): boolean {
  return useMediaQuery(shortScreenQuery)
}

export function useIsMedScreen(): boolean {
  return useMediaQuery(medScreenQuery)
}

export function useGlobeScreenHeightTier(): 'default' | 'med' | 'short' {
  const isShortScreen = useIsShort()
  const isMedScreen = useIsMedScreen()
  if (isShortScreen) return 'short'
  if (isMedScreen) return 'med'
  return 'default'
}
